/**
 * Blank left rail for the Documents and Marketplace pages.
 *
 * Both pages borrow the app shell, but neither has a model loaded, so the
 * Feature Tree's contents (generative model, physics kernel, Generate button)
 * are irrelevant there. Rather than show them — or drop the rail and let the
 * page slide left — this renders the SAME footprint the Feature Tree occupies
 * when open (16rem pane + 0.75rem edge strip = 16.75rem, same fill, same
 * border), with nothing inside and NO collapse affordance. Result: switching
 * between a model tab, Documents and Marketplace never moves the content
 * column, and the two browsing pages line up column-for-column.
 *
 * Deliberately ignores `featureTreeOpen`: the rail here is a fixed layout
 * element, not a toggle. AppMenuBar pads its tab strip by the open width on
 * these routes for the same reason.
 */
export function BlankShellSidebar() {
  return (
    <>
      <div
        className="fixed left-0 top-10 hidden lg:flex"
        style={{ bottom: 0, zIndex: 25 }}
        aria-hidden
      >
        <div className="w-64 bg-telekinesis-bg-dark" />
        {/* Edge strip — the Feature Tree's chevron strip, minus the chevron
            and the click. Keeps the right border in the identical place. */}
        <div className="w-3 flex-shrink-0 border-r border-telekinesis-neutral-700 bg-telekinesis-bg-dark" />
      </div>

      {/* Spacer — keeps the flex layout correct while the rail is fixed. */}
      <div className="hidden w-[16.75rem] flex-shrink-0 lg:block" />
    </>
  );
}
